module.exports = __webpack_public_path__ + "img/gezi.20c50d90.png";